import script from "./DatenschutzPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DatenschutzPage.vue?vue&type=script&setup=true&lang=js"

import "./DatenschutzPage.vue?vue&type=style&index=0&id=2a2c322b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2c322b"]])

export default __exports__